export default __webpack_public_path__ + "static/media/image5.6e5dff33.png";